export default __webpack_public_path__ + "static/media/plus-icon-gdi.a230c61d.svg";